export default {
  event: {
    events: 'Évènements',
    societe: 'Société',
    contact: 'Contact pour cet évènement',
    list_of_events: 'Liste des évènements',
    new_event: 'Nouvel évènement',
    participer: 'Visible',
    name_of_the_event: "Nom de l'évènement",
    date: 'Date',
    country: 'Pays',
    creator: 'Créateur',
    status: 'Statut',
    simple_extraction: 'Extraction simple',
    full_extraction: 'Extraction complète',
    upload_csv: 'Charger CSV',
    add_exhibitors: 'Ajouter des exposants',
    find_an_exhibitors: 'Trouver un exposant',
    list_of_exhibitors: 'Listes des exposants',
    export_exhibitors: 'Export exposants',
    event_informations: "Informations sur l'événement",
    start_event: "Date du début de l'événement",
    year_of_the_event: "Année de l'événement",
    select_year: "Sélectionner l'année",
    end_event: "Date de la fin de l'événement",
    city_of_event: "Ville de l'événement",
    country_of_event: "Pays de l'événement",
    registration_closing_date: 'Date de fermeture des inscriptions',
    showroom_on_event: 'Showroom sur cet événement',
    hub_on_event: 'Hub sur cet événement',
    animation_on_event: 'Animation sur cet événement',
    showroom_informations: 'Informations sur le showroom',
    hub_informations: 'Informations sur le Hub',
    animation_informations: 'Informations sur l’animation',
    questions: 'Questions',
    animation_title: "Titre de l'animation",
    animation_description: "Description de l'animation",
    thematic_title: 'Titre des thématiques',
    thematic_description: 'Description des thématiques',
    event_color: 'Couleur',
    catalog_products_limit: 'Nombre maximum de produits pour le e-catalogue',
    thematic_enabled: 'Activer les thématiques',
    thematic_selection_count: 'Nombre de sélection de choix',
    number_of_products: 'Nombre de produits',
    select_number_of_products: 'Sélectionner le nombre de produits',
    sample_informations: 'Informations sur les échantillons',
    numbers_of_sample_send: "Nombre d'échantillons à envoyer",
    address_to_send_semple: 'Adresse pour envoyer les échantillons',
    limit_date_to_receive_sample: 'Date limite pour recevoir des échantillons',
    registration: 'Enregistrement du dossier',
    event_information: 'Informations de l’évènement',
    export_profile: 'Profil export',
    questionnaire: 'Questionnaire',
    trade_name: 'Nom commercial',
    trade_name_subtitle:
      'Tel que vous souhaitez le voir apparaître sur nos différents supports de communication (stand, plan, catalogue, etc.).',
    trade_name_local: 'Nom commercial dans la langue locale',
    trade_name_local_subtitle:
      'Caractères non latins : chinois, japonais, coréen, etc.',
    trade_name_local_placeholder:
      'Nom commercial en langue locale (caractères non latins : chinois, japonais, coréen, etc.)',
    contact_for_this_event: 'Contact pour cet évènement',
    informations_visibles_sur_le_e_catalogue:
      'Informations visibles sur le e-catalogue',
    information_de_la_societe: 'Informations de la société',
    sur_name: 'Prenom',
    last_name: 'Nom',
    mobile_phone: 'Téléphone portable',
    email: 'E-Mail',
    contact_position: 'Position du contact',
    your_products: 'Votre sélection de produits',
    your_products_catalog: 'Votre sélection de produits pour le e-catalogue',
    possibility_of_presenting_up_to_10_references:
      'Possibilité de présenter jusqu’à {{count}} références',
    select_product: 'Selectionner un produit',
    add_a_new_product: 'Créer un nouveau produit',
    save: 'Enregister',
    save_and_transmit: 'Enregister et transmettre',
    possibility_to_reconnect_and_sequence_the_entry_of_information:
      '*Possibilité de vous reconnecter et séquencer la saisie des informations.',
    your_entry_is_finalized_the_elements_can_no_longer_be_modified:
      '**Votre saisie est finalisée, les éléments ne peuvent plus être modifiés.',
    date_of_event: "Date de l'événement",
    icon: 'Ajouter le produit selectionné du catalogue',
    add_product_from_catalog:
      'Ajouter le produit selectionné dans votre catalogue',
    invite: 'Inviter',
    website_title: 'Titre du site web',
    website_informations: 'Informations sur le site web',
    header_logo_left: 'Logo header gauche',
    header_logo_left_two: 'Logo n°2 Top left',
    header_logo_right: 'Logo header droit',
    subtitle_of_the_event: "Sous titre de l'évènement",
    logo: 'Logo',
    e_catalogue_url: 'URL du e-catalogue',
    inviter_par_email: 'Inviter par e-mail',
    send_email: 'Envoyer un e-mail',
    copy_the_link: 'Copier le lien',
    copy_the_link_success: "Le code d'invitation a été copié avec succès",
    invite_with_email: 'Inviter par e-mail',
    import_exhibitor_database: 'Importer base de données exposants',
    active: 'Activé',
    dossier: 'Dossier',
    edit: 'Editer',
    required: 'Ce champ est obligatoire',
    number_exhibitors: "Nombre d'exposants enregistrés à cet événement",
    number_admins: "Nombre d'administrateurs ajoutés à cet événement",
    add_exhibitor_to_the_event: "Ajouter un exposant à l'événement",
    company: 'Raison sociale',
    commercial_name: 'Nom commercial',
    type_of_product: 'Type de produit',
    color_of_wine: 'Couleur du vin',
    grape_varietal: 'Cépage',
    type_of_growing: 'Type de viticulture',
    add_exhibitor: 'Ajouter un exposant',
    add_exhibitor_to_the_event_selection: 'Ajouter les exposants selectionnés',
    exhibitror_successfilly_updated:
      'Les renseignements sur les exposants ont été mis à jour avec succès',
    add_the_least_one_product:
      'Ajouter au moins un produit avant de transmettre votre dossier',
    thematic: 'Thématique',
    thematic_choice: 'Choix thématique N°',
    download_pdf: 'Télécharger le PDF',
    ok: "d'accord",
    confirmation: 'Confirmation',
    animation: 'Animation',
    no_product_available: 'aucun produit disponible',
    showroom_logo: 'Logo showroom',
    no_thematic_found: 'Aucune thématique trouvée',
    limit: 'limite',
    preview: 'Aperçu',
    exhibitor_list: 'Liste des exposants',
    product_list: 'Liste des produits',
    offer_page: 'Page des offres',
    color: 'Couleur 1',
    second_color: 'Couleur 2',
    facturation_code: 'Code de facturation',
    category: 'Catégorie',
    select_category: 'Sélectionner une catégorie',
    all_categories: 'Toutes les catégories',
    offers: 'Offres',
    offer_name: "Nom de l'offre",
    price: 'Prix',
    price_ht: 'Prix HT',
    quantity: 'Quantité',
    total_ht: 'Total HT',
    connector_admin: 'Connector Admin',
    add: 'Ajouter',
    add_admin: 'Ajouter un admin',
    add_moderator: 'Ajouter un modérateur',
    add_moderator_to_the_event: "Ajouter un modérateur à l'événement",
    number_moderators: 'Modérateurs ajoutés à cet événement',
    no_moderator_found: 'Aucun modérateur trouvé',
    moderator_added_to_event: "Le modérateur a été ajouté à l'événement",
    moderator_removed_from_event: "Le modérateur a été retiré de l'événement",
    invite_to_admin: 'Inviter un admin',
    add_admin_to_the_event: "Ajouter un admin à l'événement",
    add_admin_to_the_event_selection: 'Ajouter les admins sélectionnés',
    already_added: 'Déjà ajouté',
    remove_admin: 'Retirer',
    no_admin_found: 'Aucun admin trouvé',
    admin_added_to_event: "L'admin a été ajouté à l'événement",
    admin_removed_from_event: "L'admin a été retiré de l'événement",
    connector: 'Connecteur',
  },
};
